import React, { Component } from 'react';

class IconSidebarItemDataGroup extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="24"
                fill="none"
                viewBox="0 0 26 24"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    fillRule="evenodd"
                    d="M21.53 10.226h-.885v-.413a1.315 1.315 0 00-1.314-1.315h-.58v-.306a1.314 1.314 0 00-1.314-1.306h-4.663a1.315 1.315 0 00-1.315-1.265h-.546a1.817 1.817 0 010-.306A1.305 1.305 0 009.615 4h-5.3A1.315 1.315 0 003 5.315v9.988a1.315 1.315 0 001.315 1.315h.579v.34A1.314 1.314 0 006.2 18.271h.934v.413A1.323 1.323 0 008.45 20H21.53a1.315 1.315 0 001.315-1.323v-7.144a1.315 1.315 0 00-1.315-1.307zm-2.2-.413v.413h-2.786a1.571 1.571 0 01-1.058-.413h3.845zm-1.893-1.654v.306h-2.48a1.262 1.262 0 00-.067-.306h2.547zM4.894 6.927v8.376h-.58V5.315h5.301v.306H6.2a1.306 1.306 0 00-1.306 1.306zm2.24 1.761v8.27H6.2V6.927h5.259a3.316 3.316 0 000 .413H8.408a1.315 1.315 0 00-1.274 1.347zm14.396 9.989H8.408V8.688h5.259c-.005.385.074.766.231 1.117a2.87 2.87 0 002.646 1.76h4.961l.025 7.112zm-3.729-5.474h2.696a.414.414 0 000-.827H17.8a.414.414 0 000 .827zm2.696 1.19H17.8a.421.421 0 01-.413-.413.414.414 0 01.413-.413h2.696a.414.414 0 01.413.413.422.422 0 01-.413.414z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconSidebarItemDataGroup;